import { shallowEqual } from 'react-redux';

import { Alert, Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';

const PartialListingBanner = () => {
  const {
    isFeed,
    partialListing: { isPartialListingManaged, partialFeedName },
  } = useSelector(
    (state) => ({
      isFeed: state?.properties?.currentProperty?.isFeed,
      partialListing: state?.properties?.currentProperty?.partialListing,
    }),
    shallowEqual,
  );

  if (isFeed || !isPartialListingManaged) {
    return null;
  }

  return (
    <Spacer marginBottom="md">
      <Alert
        appearance="info"
        body={
          <Text>
            {partialFeedName} is the pricing and availability source for this listing. Edits to property details and
            media can be made on Zillow, but edits to availability and pricing must be made through {partialFeedName}.
          </Text>
        }
      />
    </Spacer>
  );
};

export default PartialListingBanner;
